// Errors with this parameter are internal step diagnostics, only admins see them on the DataLayer Guard dashboard
export const STEP_FAILURE_PARAMETER = "_preceding_step_failure";

/**
 * Whether a DataLayer Guard error is a step failure (internal step diagnostics, not a real error for the client)
 *
 * @param {object} error - Error row of the DataLayer Guard dashboard endpoint
 * @returns {boolean} True for a step failure
 */
export const isStepFailure = (error) =>
  (error?.parameters?.[0]?.parameter_name || error?.parameter_name) === STEP_FAILURE_PARAMETER;
